import { dealerPrice, privatePrice } from 'db/constants/prices'

// Ceny ogłoszeń z tego samego modułu co naliczanie płatności (resolveOfferPriceForUser).
export const PRIVATE_LISTING = { price: `${privatePrice} zł`, days: 30 }
export const FIRM_LISTING = { price: `${dealerPrice} zł`, days: 30 }
// Najniższa cena ogłoszenia (konto prywatne albo firmowe).
export const LISTING_FROM = { price: `${Math.min(dealerPrice, privatePrice)} zł`, days: 30 }
